import GameVersion from 'app/frontend/types/custom/GameVersion'
import { hasAccessToContent } from '../config/permissions'
import { compareTeamsByDefaultAndName } from './teamOrdering'

export type LinkedTeamGroup = {
  linkedGuild: wowaudit.LinkedGuild
  teams: wowaudit.TeamReference[]
  isOtherGameVersion: boolean
}

export type LinkedTeamHref = { internal: string } | { external: string }

export const linkedTeamGroups = (
  guild: Pick<wowaudit.Guild, 'linkedGuilds'> | undefined,
  currentGameVersion: GameVersion,
  {
    visibleOnly = false,
    requireAccess = false,
  }: { visibleOnly?: boolean; requireAccess?: boolean } = {},
): LinkedTeamGroup[] =>
  (guild?.linkedGuilds ?? [])
    .map((linkedGuild) => ({
      linkedGuild,
      isOtherGameVersion: linkedGuild.gameVersion !== currentGameVersion,
      teams: linkedGuild.teamReferences
        .filter((team) => !visibleOnly || team.visibleInGuild)
        .filter(
          (team) =>
            !requireAccess ||
            hasAccessToContent('member', 'base', linkedGuild, team).hasAccess,
        )
        .sort(compareTeamsByDefaultAndName),
    }))
    .filter((group) => group.teams.length > 0)

// Teams of another game version live on another host, and custom domains can
// only serve their own guild, so those links need a full page navigation.
export const linkedTeamHref = (
  team: { path: string; fullUrl?: string | null },
  {
    isOtherGameVersion,
    onCustomDomain,
  }: { isOtherGameVersion: boolean; onCustomDomain: boolean },
): LinkedTeamHref =>
  (isOtherGameVersion || onCustomDomain) && team.fullUrl
    ? { external: team.fullUrl }
    : { internal: team.path }
